import { atom } from 'jotai';
const INITIAL_VALUE = Symbol('INITIAL_VALUE');
export const defineOnceAtom = () => {
    const innerAtom = atom(INITIAL_VALUE);
    const onceAtom = atom((get) => get(innerAtom), (get, set, value) => {
        const current = get(innerAtom);
        if (current === INITIAL_VALUE) {
            set(innerAtom, value);
        }
    });
    return onceAtom;
};
export const defineProxyAtom = (target) => {
    const proxyAtom = atom((get) => get(target), (_, set, value) => {
        set(target, value);
    });
    return proxyAtom;
};
